import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getPlanByLicense,
  getTrialLicenseByType,
} from 'Settings/pricing-options';
import {
  getActiveUser,
  getFailedLoginErrorVars,
  getForm,
} from 'Store/reducers';
import Error from 'Containers/Error';

import { withRouter } from 'react-router';
import { FORM_ID } from 'Containers/paymentForms/SubscriptionPurchaseForm';

class ExpiredTrialErrorPage extends React.PureComponent {
  render() {
    const { activeUser, user } = this.props;
    if (!user || activeUser) {
      return <Error type="pageNotFound" code={404} />;
    }
    return <Error type="expiredTrial" />;
  }
}

const mapStateToProps = (state, { location }) => {
  const failedLoginErrorVars = getFailedLoginErrorVars(state);
  const expiredAdminPassword = failedLoginErrorVars
    ? failedLoginErrorVars.password
    : undefined;

  const newProps = {
    activeUser: getActiveUser(state),
    form: getForm(state, FORM_ID),
    expiredAdminPassword,
  };

  if (failedLoginErrorVars) {
    const { license, user, school } = failedLoginErrorVars;
    let licenseType;
    if (license) licenseType = license.license_type;
    if (location.state && location.state.licenseType)
      licenseType = getTrialLicenseByType[location.state.licenseType];
    newProps.user = user;
    newProps.plan = getPlanByLicense(licenseType);
    newProps.school = school;
  }
  return newProps;
};

ExpiredTrialErrorPage.propTypes = {
  user: PropTypes.object,
  plan: PropTypes.object,
  school: PropTypes.object,
  expiredAdminPassword: PropTypes.string,
};

export default withRouter(connect(mapStateToProps)(ExpiredTrialErrorPage));
